/**
 * ResultCountDisplay Component
 * 
 * Displays the count of matches with appropriate text based on filter state.
 * Includes aria-live region for screen reader announcements.
 */

import React from 'react';

interface ResultCountDisplayProps {
  totalCount: number;
  filteredCount: number;
  entityType: 'candidates' | 'jobs';
  hasActiveFilters: boolean;
}

const ResultCountDisplay: React.FC<ResultCountDisplayProps> = ({
  totalCount,
  filteredCount,
  entityType,
  hasActiveFilters
}) => {
  const displayCount = hasActiveFilters ? filteredCount : totalCount;
  const entityText = entityType === 'candidates' ? 'candidate' : 'job';
  const pluralSuffix = displayCount === 1 ? '' : 's';
  
  const message = hasActiveFilters
    ? `${displayCount} ${entityText}${pluralSuffix} match filters`
    : `${displayCount} ${entityText}${pluralSuffix} applied`;

  return (
    <div 
      className="text-sm text-gray-600 mb-4"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      {message}
    </div>
  );
};

export default ResultCountDisplay;
